import Vue from 'vue'
import VueRouter from 'vue-router'
import SignUp from '../views/signup.vue'
import { guard } from '@/auth/guard'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'SignUp',
    component: SignUp,
    meta: { auth: true },
  },
  {
    path: '/failure',
    name: 'Failure',
    component: () => import(/* webpackChunkName: "failure" */ '@/views/failure.vue'),
    meta: { auth: true },
  },
  {
    path: '/success',
    name: 'Success',
    component: () => import(/* webpackChunkName: "pending" */ '@/views/success.vue')
  },
  {
    path: '*',
    component: SignUp,
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach(guard)

export default router
